import { Injectable, Signal, signal } from "@angular/core";
import { listGroup } from "./list-items.interface";

@Injectable({ providedIn: 'root' })
export class GeneralNavigationService {
    private showMenuSignal = signal<boolean>(false);
    private menuStateSignal = signal<boolean>(false);
    private menuTypeSignal = signal<'navigation-rail' | 'navigation-menu' | 'navigation-modal'>('navigation-rail');
    private menuItemsSignal = signal<listGroup[]>([]);

    constructor() {
    }

    public set menuState(active: boolean) {
        this.menuStateSignal.set(active);
    }

    public get menuState(): Signal<boolean> {
        return this.menuStateSignal.asReadonly();
    }

    public set showMenu(show: boolean) {
        this.showMenuSignal.set(show);
    }

    public get showMenu() {
        return this.showMenuSignal();
    }

    public set menuType(type: 'navigation-rail' | 'navigation-menu' | 'navigation-modal') {
        this.menuTypeSignal.set(type);
    }

    public get menuType() {
        return this.menuTypeSignal();
    }

    public set menuItems(items: listGroup[]) {
        this.showMenu = items.length > 0;
        this.menuItemsSignal.set(items);
    }

    public get menuItems() {
        return this.menuItemsSignal();
    }

    public toggleState() {
        let state = !this.menuState();
        this.menuState = state;
    }
}